/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
/**
 * 
 * @export
 * @interface LoginViewModel
 */
export interface LoginViewModel {
    /**
     * 
     * @type {string}
     * @memberof LoginViewModel
     */
    emailAddress: string;
    /**
     * 
     * @type {string}
     * @memberof LoginViewModel
     */
    password: string;
    /**
     * 
     * @type {boolean}
     * @memberof LoginViewModel
     */
    rememberMe?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof LoginViewModel
     */
    $type?: LoginViewModelTypeEnum;
}


/**
 * @export
 */
export const LoginViewModelTypeEnum = {
    PtwPtw100WebMvcModelsAccountLoginViewModelPtwPtw100WebMvc: 'Ptw.Ptw100.Web.Mvc.Models.Account.LoginViewModel, Ptw.Ptw100.Web.Mvc'
} as const;
export type LoginViewModelTypeEnum = typeof LoginViewModelTypeEnum[keyof typeof LoginViewModelTypeEnum];


/**
 * Check if a given object implements the LoginViewModel interface.
 */
export function instanceOfLoginViewModel(value?: unknown): value is LoginViewModel {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(LoginViewModelTypeEnum)[0];
}

export function LoginViewModelFromJSON(json: any): LoginViewModel {
    return LoginViewModelFromJSONTyped(json, false);
}

export function LoginViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): LoginViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'emailAddress': json['emailAddress'],
        'password': json['password'],
        'rememberMe': !exists(json, 'rememberMe') ? undefined : json['rememberMe'],
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function LoginViewModelToJSON(value?: LoginViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'emailAddress': value.emailAddress,
        'password': value.password,
        'rememberMe': value.rememberMe,
        '$type': value.$type,
    });
}

